import { drawCircle, drawLine } from '../2D/drawing'
import pitchTexture from '../../../assets/img/pitch-texture.png'

export function applyDemonstrationSettings(field, dimensions) {
  field.height = dimensions.P1.y - dimensions.P2.y
  field.width = dimensions.P3.x - dimensions.P2.x
  field.edges = 10

  field.planes = {
    left: dimensions.P1.x,
    right: dimensions.P3.x,
    top: dimensions.P1.y,
    bottom: dimensions.P2.y
  }

  // Set origin offset to centralise pitch lines
  field.originOffsetX =
    (Math.abs(dimensions.P2.x) - Math.abs(dimensions.P3.x)) / 2
  field.originOffsetY =
    -(Math.abs(dimensions.P2.y) - Math.abs(dimensions.P1.y)) / 2

  field.color = '#089b64'
}

// Draw rugby pitch background on 2D canvas
export const drawDemonstrationLines = (props, color, ctx, pixelScale, view) => {
  const { field, dimensions, canvasElementPixelRatio, zoom } = props

  let getCanvasCoordinate = props.getCanvasCoordinate

  if (view === '3D') {
    getCanvasCoordinate = props.get3DCanvasCoordinate
  }

  // Border

  ctx.beginPath()
  ctx.setLineDash([0])
  ctx.moveTo(
    getCanvasCoordinate(pixelScale, dimensions.P1.x).scaleX,
    getCanvasCoordinate(pixelScale, null, dimensions.P1.y).scaleY
  )
  ctx.lineTo(
    getCanvasCoordinate(pixelScale, dimensions.P2.x).scaleX,
    getCanvasCoordinate(pixelScale, null, dimensions.P2.y).scaleY
  )
  ctx.lineTo(
    getCanvasCoordinate(pixelScale, dimensions.P3.x).scaleX,
    getCanvasCoordinate(pixelScale, null, dimensions.P3.y).scaleY
  )
  ctx.lineTo(
    getCanvasCoordinate(pixelScale, dimensions.P4.x).scaleX,
    getCanvasCoordinate(pixelScale, null, dimensions.P4.y).scaleY
  )
  ctx.lineTo(
    getCanvasCoordinate(pixelScale, dimensions.P1.x).scaleX,
    getCanvasCoordinate(pixelScale, null, dimensions.P1.y).scaleY
  )

  ctx.fillStyle = 'rgba(0,0,0,0.1)'

  ctx.fill()

  ctx.lineWidth = 0.05 * pixelScale
  ctx.strokeStyle = color
  ctx.stroke()

  for (let i = -200; i < 200; i++) {
    drawLine(
      i,
      field.height * 4,
      i,
      -field.height * 4,
      ctx,
      null,
      i === 0 ? 2 : 1,
      i === 0 ? 'red' : 'rgba(255,255,255,0.5)',
      getCanvasCoordinate,
      pixelScale
    )
  }

  for (let i = -200; i < 200; i++) {
    drawLine(
      field.width * 4,
      i,
      -field.width * 4,
      i,
      ctx,
      null,
      i === 0 ? 2 : 1,
      i === 0 ? 'red' : 'rgba(255,255,255,0.5)',
      getCanvasCoordinate,
      pixelScale
    )
  }
}
